export function doesAccountNameSatisfyQuery(
  accountName: string,
  query: string
): boolean {
  if (!accountName || !query) {
    return false
  }

  const methodToUse = isNaN(parseInt(query, 10)) ? 'includes' : 'startsWith'

  return accountName.toLowerCase()[methodToUse](query.toLowerCase())
}
